import { render, staticRenderFns } from "./ClientService.vue?vue&type=template&id=0ed0cf2f&"
import script from "@/views/Authed/ClientService/ClientService.js?vue&type=script&lang=js&"
export * from "@/views/Authed/ClientService/ClientService.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports